<template>
  <i :class="classes"></i>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    classes() {
      return ["iconfont", `icon-${this.icon}`];
    },
  },
};
</script>

<style lang="less">
@import "iconfont";
</style>
